// Split out from List.tsx so it can be unit-tested without pulling in that file's MUI/Iconify
// import chain (Iconify ships ESM that this project's CRA/Jest setup cannot transform).

// The views to name in a confirmation before flipping `enabled`, or `[]` if none is needed.
// Enabling is always harmless (nothing to warn about). Disabling is reversible too — no tags are
// ever deleted — but any view whose rule names this sector goes empty while it's off, and that
// isn't obvious from this screen. An empty referencingViewCodes means disabling has no visible
// consequence here, so no confirmation is worth showing — it would be friction with nothing to
// say.
export function viewsToWarnAbout(enabled: boolean, referencingViewCodes: string[] | undefined): string[] {
  if (enabled) return [];
  return referencingViewCodes ?? [];
}
